<template>
  <el-dialog
    append-to-body
    width="600px"
    destroy-on-close	
    :title="`${isChange ? '编辑供应商' : '创建供应商'}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    >
      <el-form
        label-position="top"
        class="staff-from"
        v-loading="loading"
        element-loading-text="加载中…"
        ref='elFormDom'
        label-width='auto'
        :model='form.data'
        :rules='form.rules'
        :size="subUnitSize"
      >
        <div class="itemTime">基础信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="简称" prop="name">
              <el-input
                v-model.trim="form.data.name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照名称" prop="license_no">
              <el-input
                v-model.trim="form.data.license_no"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contact">
              <el-input
                v-model.trim="form.data.contact"
                maxlength="11"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contact_phone">
              <el-input
                v-model.trim="form.data.contact_phone"
                maxlength="11"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="登录账号" prop="account">
              <el-input
                v-model.trim="form.data.account"
                maxlength="11"
                placeholder="请输入"
                clearable
                :disabled="isChange"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 超级管理员选地区 v-if="roleType == 1" -->
            <!-- 登录的有地区不可以选、没地区可以选 -->
            <el-form-item label="供货地区" prop="area">
              <el-cascader
                v-model="form.data.area"
                :options="areaArr"
                :disabled='getAreaDisabled()'
                :props="{ checkStrictly: false }"
                clearable
                filterable
                style="width:100%;">
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="供货类别" prop="order_cate_id">
                <el-select v-model="form.data.order_cate_id"  filterable style="width:100%;" placeholder="请选择">
                  <el-option
                  v-for="item in orderCateArr"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采买方式" prop="buy_type">
              <el-radio-group v-model="form.data.buy_type" v-removeAriaHidden>
                <el-radio :label="1">现金采买</el-radio>
                <el-radio :label="2">非现金采买</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="结算周期" prop="settle_day">
              <el-select v-model="form.data.settle_day"  filterable style="width:100%;" placeholder="请选择">
                <el-option
                v-for="item in settleDayOpt"
                :label="item.name"
                :value="item.id"
                :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对接人" prop="contact_id">
              <el-select v-model="form.data.contact_id"  filterable style="width:100%;" placeholder="请选择">
                <el-option
                v-for="item in purchasePersonOpt"
                :label="item.name"
                :value="item.id"
                :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="次对接人" prop="contact_two_id">
              <el-select v-model="form.data.contact_two_id"  filterable style="width:100%;" placeholder="请选择">
                <el-option
                v-for="item in purchasePersonOpt"
                :label="item.name"
                :value="item.id"
                :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 空列，保持布局对齐 -->
          </el-col>
        </el-row>
        <!-- 提供代分拣单独一行，因为有说明图标 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="提供代分拣" prop="is_sorter">
              <template slot="label">提供代分拣
                <el-popover
                  placement="top"
                  width="300"
                  v-model="visiblePopover">
                  <p style="text-indent: 25px;padding:0 5px;">
                    提供代分拣指供应商供应商品将按照客户下单食堂分别拣好并投篮，
                    若提供该服务请选择是（采购收货将需要您根据不同食堂采购数量逐一登记）；
                    若不提供您可选择否（采购收货将统一采购统一登记收货）</p>
                  <div style="text-align: center; margin: 0">
                    <el-button type="text" size="mini" @click="visiblePopover = false">我知道了</el-button>
                  </div>
                  <i slot="reference" class="el-icon-question" style="padding:0 10px;font-size: 20px;color: #2cb167;"></i>
                </el-popover>
              </template>
              <el-radio-group @input="issorterChange" v-model="form.data.is_sorter" v-removeAriaHidden>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.data.is_sorter == 1">
            <el-form-item label="录单数取订单数" prop="show_num">
              <el-radio-group v-model="form.data.show_num" v-removeAriaHidden>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="供应客户" prop="merchant_ids">
          <el-select v-model="form.data.merchant_ids" multiple filterable style="width:100%;">
            <el-option
            v-for="item in merchantArr"
            :label="item.name"
            :value="item.id"
            :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <div class="itemTime">收款信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户名称" prop="bank_account">
              <el-input
                v-model.trim="form.data.bank_account"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户银行" prop="bank_name">
              <el-input
                v-model.trim="form.data.bank_name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="银行账号" prop="bank_code">
              <el-input
                v-model.trim="form.data.bank_code"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联行号" prop="tax_code"
              :rules="form.data.bank_account.length>4?[]:[{ required: true, message:'开户名称若为个人则必填', trigger: ['blur', 'change']}]"
            >
              <el-input
                v-model.trim="form.data.tax_code"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="itemTime">合作资料</div>
        <el-form-item label="证件照片" prop="sfz_license">
          <div style="display:flex;">
            <div>
              <uploadOnly v-model="form.data.id_card_zm"></uploadOnly>
              <div style="text-align:center">身份证正面</div>
            </div>
            <div>
              <uploadOnly v-model="form.data.id_card_fm"></uploadOnly>
              <div style="text-align:center">身份证反面</div>
            </div>
            <div>
              <uploadOnly v-model="form.data.license_img"></uploadOnly>
              <div style="text-align:center">营业执照</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="合同/协议" prop="contract">
          <el-upload
              class="upload-demo"
              action="/api/common/qiniu/uploadFile"
              :limit="10"
              :multiple="true"
              :on-preview="handlePictureCardPreview"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :file-list="form.data.contract"
              :headers="{ token: token }"
              ref='uploadDom'
              accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls "
            >
              <el-button :size="subUnitSize" type="primary" plain
                >请上传</el-button
              >
          </el-upload>
        </el-form-item>
      </el-form>
     
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click='toggle(false)'>取消</el-button>
        <el-button type="primary" :loading="form.loading" :disabled="form.loading" @click='confirm'>确定</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
  import common from '@/util'
  import { REG_EXP } from '@/util'
  import { getStorage } from '@/storage'
  import { mixinTable } from '@/mixins/table.js'
  import uploadOnly from '@/components/uploadOnly'
  export default {
    name: 'SupplierEdit',
    components: { uploadOnly },
    mixins: [mixinTable],
    data() {
      // 自定义校验函数 - 证件照片验证
      const validateSfzLicense = (rule, value, callback) => {
        const { id_card_zm, id_card_fm, license_img } = this.form.data;
        // 检查三个证件是否都有值（数组长度大于0）
        if (id_card_zm && id_card_zm.length > 0 && 
            id_card_fm && id_card_fm.length > 0 && 
            license_img && license_img.length > 0) {
          // 三个证件都有值，验证通过
          callback();
        } else {
          // 三个证件缺一个，提示必须上传全部证件
          callback(new Error('请上传'));
        }
      };
      return {
        roleType: getStorage('role_type'),
        login_province: getStorage('province'),
        login_city: getStorage('city'),
        subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
        visible: false,
        isChange: false,
        loading: false,
        settleDayOpt: [
          {name: '当天', id: 1},
          {name: '7天', id: 2},
          {name: '10天', id: 3},
          {name: '15天', id: 4},
          {name: '30天', id: 5},
          {name: '45天', id: 6},
        ], // 结算周期

        form: {
          loading: false,
          data: {
            id: '',
            name: "", //名称
            contact: "", //联系人
            contact_phone: "", //联系人电话
            account: "", //账户
            province: "", //省
            city: "", //市
            area: '',
            bank_account: "", //开户名称
            bank_name: "", //开户银行
            bank_code: "", //银行账号
            tax_code: "", //税号
            is_sorter: 2, // 是否代分拣,默认否
            show_num:'',
            // merchant_ids: "", //供应客户 
            license_no:"", //营业执照号
            order_cate_id:'',
            contact_id:'',
            contact_two_id:'',
            settle_day:'',
            id_card_zm: [], //证件照片
            id_card_fm: [], //证件照片
            license_img: [], //营业执照照片
            contract:[], //合同/协议
            buy_type:'',
          },
          rules: {
            name: [{ required: true, message:'请输入名称', trigger: 'change'}],
            license_no: [{ required: true, message:'请输入营业执照', trigger: 'change'}],
            contact: [{ required: true, message:'请输入联系人', trigger: 'change'}],
            contact_phone: [
              { required: true, message:'请输入联系电话', trigger: 'change'},
              {
                pattern: REG_EXP.mobilePhone,
                message: '请输入正确的手机号',
                trigger: 'change'
              }
            ],
            account: [{ required: true, message:'请输入登录账号', trigger: 'change'}],
            area: [{ required: true, message:'请选择供货地区', trigger: 'change'}],
            is_sorter: [{ required: true, message:'请选择', trigger: 'change'}],
            bank_account: [{ required: true, message:'请输入', trigger: 'change'}],
            bank_name: [{ required: true, message:'请输入', trigger: 'change'}],
            bank_code: [{ required: true, message:'请输入', trigger: 'change'}],
            order_cate_id: [{ required: true, message:'请选择供货类别', trigger: 'change'}],
            buy_type: [{ required: true, message:'请选择', trigger: 'change'}],
            settle_day: [{ required: true, message:'请选择', trigger: 'change'}],
            contact_id: [{ required: true, message:'请选择', trigger: 'change'}],
            sfz_license: [{required: true, validator: validateSfzLicense, trigger: 'change'}],
            contract: [{ required: true, message:'请上传', trigger: 'change'}],
          }
        },
        areaArr: [],
        merchantArr: [],
        visiblePopover: false,
        orderCateArr: [], // 下单分类
        purchasePersonOpt: [], // 采购员
      }
    },
    methods: {
      getDetail(row) {
        this.getArea();
        this.getMerchant();
        if(!!row.id) {
          this.isChange = true
          this.$nextTick(() => {
            common.deepClone(this.form.data, row)
            this.form.data.area = [row.province, row.city];
            this.form.data.id_card_zm = row.id_card_zm?[{url:row.id_card_zm}]:[];
            this.form.data.id_card_fm = row.id_card_fm?[{url:row.id_card_fm}]:[];
            this.form.data.license_img = row.license_img?[{url:row.license_img}]:[];
            this.form.data.contact_two_id = row.contact_two_id?row.contact_two_id:'';
            this.form.data.contract = row.contract&&row.contract.length?row.contract.map(item => ({url: item.file,name:item.name})):[];
            // this.form.data.merchant_ids = !!row.merchant_ids ? row.merchant_ids.split("|").map(Number) : '';
          })
        }else {
          this.form.data.area = this.getAreaCode.length?this.getAreaCode:[];
        }
      },
      getAreaDisabled() {
        if(this.getAreaCode.length&&!this.isChange){
          return true
        }
        return false
      },
      // 获取全国省市区
      getArea() {
        this.$http.post('/common/district/all', {is_all:1}).then(res => {
          if(res.code === 1) {
            this.areaArr = res.data.list;
            for (const key in this.areaArr) {
              // 删除第三层children属性
              for (const i in this.areaArr[key].children) {
                  delete this.areaArr[key].children[i].children
              }
            }
          }
        })
      },
      // 获取客户列表
      getMerchant() {
        // type 1:列表 2:参数
        this.$http.get("/admin/group/merchantList", {params:{type:1,page:1,count:10000}}).then((res) => {
          if(res.code == 1) {
            this.merchantArr = res.data.list;
          }
        })
      },
      reset(done) {
        this.isChange = false
        // 清空表单数据
        this.$refs.elFormDom.resetFields()
        // 手动清空照片文件
        this.form.data.id_card_zm = []
        this.form.data.id_card_fm = []
        this.form.data.license_img = []
        this.form.data.contract = []
        this.form.data.id = '';
        done && done()
      },
      toggle(show) {
        this.visible = show
        !show && this.reset()
      },
      issorterChange() {
        this.form.data.show_num = ''
      },
      // 提交
      confirm() {
        const allFiles = this.$refs.uploadDom.uploadFiles;
        console.log(allFiles,'allFiles')
        if(allFiles.length){
          this.form.data.contract = allFiles.map(item =>{
            return {
              file:(item.file|| item.url) || item.response.data.all_path_url,
              name:item.name,
            }
          })
        }
        console.log(allFiles,'allFiles')
        console.log(this.form.data,'this.form.data')
        this.$refs.elFormDom.validate(valid => {
          if (valid) {
            let _params = {
              id: this.form.data.id,
              name: this.form.data.name,
              contact: this.form.data.contact,
              contact_phone: this.form.data.contact_phone,
              account: this.form.data.account,
              province: this.form.data.area[0] ,
              city: this.form.data.area[1] ,
              bank_account: this.form.data.bank_account,
              bank_name: this.form.data.bank_name,
              bank_code: this.form.data.bank_code,
              tax_code: this.form.data.tax_code,
              is_sorter: this.form.data.is_sorter,
              show_num: this.form.data.show_num,
              license_no: this.form.data.license_no,
              order_cate_id: this.form.data.order_cate_id,
              buy_type: this.form.data.buy_type,
              settle_day: this.form.data.settle_day,
              contact_id: this.form.data.contact_id,
              contact_two_id: this.form.data.contact_two_id,
              id_card_zm: this.form.data.id_card_zm.map(item => item.url).join(),
              id_card_fm: this.form.data.id_card_fm.map(item => item.url).join(),
              license_img: this.form.data.license_img.map(item => item.url).join(),
              contract: this.form.data.contract,
              // merchant_ids: !!this.form.data.merchant_ids ? this.form.data.merchant_ids.join("|") : '',
            };
            let apiUrl = this.isChange ? '/admin/supplier/edit' : '/admin/supplier/add'
            this.form.loading = true;
            this.$http.post(apiUrl, _params).then(res => {
              if(res.code === 1) {
                this.toggle(false);
                this.$emit('refresh')
              }
            }).finally(() => {
              this.form.loading = false;
            })
          }
        })
      },
      handlePictureCardPreview(file) {
          window.open(file.url);
      },
    handleAvatarSuccess(res, file, fileList) {
        // this.form.data.contract = fileList.map((item) => {
        //   return {
        //     url: item?.response?.data?.all_path_url || item.url,
        //     name: item.name,
        //   };
        // });
        // console.log(res, 'res');
        //  let strImg = {
        //   url: res.data.all_path_url,
        //   name: file.name,
        // };
      // this.form.data.contract.push(strImg);
    },
    handleRemove(file, fileList) {
      // this.form.data.contract = fileList.map((item) => {
      //     return {
      //       url: item.url || item.response.data.all_path_url,
      //       name: item.name,
      //     };
      //   });
    },
    handleExceed() {
      this.$message.warning('最多传10个文件')
    },
    },
    mounted() {
      this.getPurchasePerson();
      this.getOrderCateSel();
    },
    computed:{
      getAreaCode() {
        let provice = getStorage('province');
        let city = getStorage('city');
        if(provice && city){
          return [provice, city]
        }else {
          return []
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.imgWrap {
  width: 90px;
  overflow: hidden;
  height: 80px;
}
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.label-ell {
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 120px;
}

/* 分组标题样式 */
.itemTime {
  margin: 0px 0 15px 0;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 8px;
}

/* 确保表单项在小屏幕下也能正常显示 */

</style>
